import { AttachmentType, ShareMessageContentFragment } from "~/__generated__/graphql"
import { UserAvatar } from "~/ui/user-avatar"
import MessageHeader from "../message-header"
import { MessageAttachments } from "./message-attachments"
import { FormattedAppText } from "~/ui/formatted-app-text"
import { AppText } from "~/ui/app-text"

interface QuotedMessageProps {
  quotedMessage: ShareMessageContentFragment
}

const SUPPORTED_QUOTED_ATTACHMENT_TYPES = [
  AttachmentType.Image,
  AttachmentType.AuraSticker,
  AttachmentType.Giphy,
  AttachmentType.Video,
]

export const QuotedMessage: React.FC<QuotedMessageProps> = ({ quotedMessage }) => {
  const user = quotedMessage.user
  const displayName = user?.displayName || user?.username || "User"
  const hasAttachments = quotedMessage.attachments?.length > 0
  const supportedQuotedAttachment = SUPPORTED_QUOTED_ATTACHMENT_TYPES.includes(
    quotedMessage.attachments?.[0]?.attachmentType
  )
  return (
    <div className="flex w-fit flex-row justify-between gap-3 rounded-md bg-neutral-200 px-4 py-3">
      <div className="flex flex-col gap-1">
        <div className="flex w-fit flex-row items-center gap-2">
          <UserAvatar avatarUrl={user?.avatarUrl} displayName={displayName} size="xsm" />
          <MessageHeader
            showVerified={user?.verifiedAccount}
            displayName={displayName}
            textVariant="body3-medium"
          />
        </div>
        {quotedMessage?.textContent && (
          <FormattedAppText
            text={quotedMessage.textContent}
            variant="body3-medium"
            className="line-clamp-2 whitespace-pre-wrap"
          />
        )}
        {hasAttachments && !supportedQuotedAttachment && (
          <AppText variant="body3-medium">Shared an attachment</AppText>
        )}
      </div>
      {hasAttachments && supportedQuotedAttachment && (
        <div className="flex max-w-[48px] items-center justify-center">
          <MessageAttachments
            attachments={quotedMessage.attachments}
            playable={false}
            className="rounded-xs"
          />
        </div>
      )}
    </div>
  )
}
